import { defineElement, FC, onDidLoad, useProp } from '@atomify/hooks';
import { useStore } from '@bpd-library/utilities';
import { isSubscribedToProjectPhase, subscriptionStore } from '@store/subscription/store';
import { SubscriptionStoreState } from '@store/subscription/store.types';

const SubscriptionHelperText: FC = ({ element }) => {
    const [projectPhaseId] = useProp<string>('projectPhaseId', '');
    const [, subscribe] = useStore<SubscriptionStoreState>(subscriptionStore);

    subscribe(init, ['projectPhases', 'user']);
    onDidLoad(init);

    function init() {
        const helperTextHidden = isSubscribedToProjectPhase(projectPhaseId);
        element.classList.toggle('u-hidden', helperTextHidden);
    }
};

SubscriptionHelperText.props = {
    projectPhaseId: {
        type: String,
        required: true,
    },
};

defineElement('subscription-helper-text', SubscriptionHelperText);
